import React, { Component } from 'react'
import SuburbCard from './cards/suburb'

class Suburbs extends Component {

  state = {
    location: false
  }

  componentDidMount() {
    this._toggleLocation(0)
  }

  _toggleLocation = (item) => {
    if ( this.state.location[item] ) return
    this.setState({location: {[item]: !this.state.location[item]} })
  }

  render() {

    let { title, content, menu } = this.props
    let { location } = this.state

    return (
      <section className='suburbs'>
        <div className='suburbs__inner'>
          <div className='suburbs__sidebar'>
            <div className='suburbs__title'>
              <h1>{title}</h1>
              <p dangerouslySetInnerHTML={{ __html: content }} />
              { menu?.length > 0 &&  
                <ul>
                  {menu.map((el, i) => (
                    <li className={location[i] && 'active'} key={i}>
                      <button 
                        type='button'
                        onClick={() => this._toggleLocation(i)}
                      >
                        {el.title}
                      </button>
                    </li>
                  ))}
                </ul>
              }
            </div>
          </div>
          <div className='suburbs__body'>
            { menu?.length > 0 && menu.map((el, i) => (
              <div className={`suburbs__items ${location[i] && 'active'}`} key={i}>
                { el.suburbs?.length > 0 && el.suburbs.map((suburb, s) => (
                  <SuburbCard {...suburb} />
                )) }
              </div>
            ))}
          </div>
        </div>
      </section>
    )
  }
}

export default Suburbs